import { useSession } from '../components/video/session-provider';
import { useVideoConfig } from '../components/video/video-config-provider';
import { createArray } from '../utils/array';
const VIDEOS_PER_PAGE = 16;
const VIDEOS_PER_PAGE_MOBILE = 4;
export const useGridLayout = (currentPage) => {
    const { mobile } = useVideoConfig();
    const { attendees, currentAttendeeId, focusedAttendeeId } = useSession();
    const videosPerPage = mobile ? VIDEOS_PER_PAGE_MOBILE : VIDEOS_PER_PAGE;
    const pagesCount = Math.ceil(attendees.length / videosPerPage);
    const visibleAttendeeIds = getVisibleAttendeeIds(attendees, currentAttendeeId, focusedAttendeeId, pagesCount, currentPage, videosPerPage);
    const sortedAttendeeIds = attendees
        .slice()
        .sort((attendeeIdA, attendeeIdB) => visibleAttendeeIds.indexOf(attendeeIdA) - visibleAttendeeIds.indexOf(attendeeIdB));
    return {
        attendees: sortedAttendeeIds,
        pagesCount,
        visibleAttendeeIds,
        focusedAttendeeId,
    };
};
const getVisibleAttendeeIds = (attendees, currentAttendeeId, activeAttendeeId, pagesCount, currentPage, videosPerPage) => {
    const activeAttendeesCount = 2; // focused and current
    const nonActiveAttendees = attendees.filter(attendeeId => attendeeId !== currentAttendeeId && activeAttendeeId !== attendeeId);
    if (pagesCount === 1) {
        return createArray(videosPerPage).map((_, i) => attendees[i]);
    }
    if (currentPage === 0) {
        return [
            currentAttendeeId,
            activeAttendeeId,
            ...createArray(videosPerPage - activeAttendeesCount).map((_, i) => nonActiveAttendees[i]),
        ];
    }
    return createArray(videosPerPage).map((_, i) => nonActiveAttendees[currentPage * videosPerPage + i - activeAttendeesCount]);
};
//# sourceMappingURL=grid-layout.js.map